import { defineAsyncComponent } from 'vue'
export default {
  "basic-layout": defineAsyncComponent(() => import("D:/mysrc/esoft-web/esoft-official-website/src/layouts/BasicLayout.vue").then(m => m.default || m))
}